import { Link } from "@tanstack/react-router";
import { MapPin } from "lucide-react";

function TickerSequence({ ariaHidden }: { ariaHidden: boolean }) {
  const linkProps = ariaHidden
    ? { "aria-hidden": true as const, tabIndex: -1 }
    : {};
  const sep = (
    <span aria-hidden className="text-white/20 px-6 select-none">
      ◆
    </span>
  );

  // Render the A→B→C sequence twice inside one half so very wide viewports
  // never reveal a gap before the cloned half scrolls into view.
  const Block = (
    <>
      <span className="inline-flex items-baseline gap-2 whitespace-nowrap">
        <span className="font-bold uppercase tracking-[0.18em] text-pink-soft text-[10px] md:text-[11px]">
          [ Editorial Masthead ]
        </span>
        <span className="text-white/70">
          Axy.digital Digital Market Intelligence — Real-time programmatic market
          analysis published daily at{" "}
          <span className="tabular-nums text-white/90">08:00</span> and{" "}
          <span className="tabular-nums text-white/90">16:00 UTC</span>.
        </span>
      </span>
      {sep}
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-white/70">
        <MapPin className="size-3.5 shrink-0 text-pink-soft" aria-hidden />
        <span>
          Entity:{" "}
          <span className="text-white/90">
            Auxetic Studio Pte. Ltd. (HQ: Singapore 387383)
          </span>{" "}
          | Global Nodes:{" "}
          <span className="text-white/90 tabular-nums">
            NY · LDN · CDG · LIS · BER
          </span>
        </span>
      </span>
      {sep}
      <Link
        to="/about"
        {...linkProps}
        className="inline-flex items-center gap-1 whitespace-nowrap text-pink-soft hover:text-white transition-colors font-medium"
      >
        Meet the Analysts &amp; Data Engineers →
      </Link>
      {sep}
    </>
  );

  return (
    <div className="flex items-center shrink-0 text-xs md:text-[13px]">
      {Block}
      {Block}
    </div>
  );
}

export function EditorialTicker() {
  return (
    <div
      className="ticker-mask group w-full border-b border-white/10 bg-black/60 backdrop-blur-md py-2.5"
      role="region"
      aria-label="Editorial masthead"
    >
      <div className="ticker-track flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        <TickerSequence ariaHidden={false} />
        <TickerSequence ariaHidden={true} />
      </div>
    </div>
  );
}
